module.exports = __webpack_public_path__ + "img/wips-to-cde.5e54a3b8.png";